import { gql } from 'apollo-boost';
export default gql`
  mutation setPresence($online: Boolean!) { setPresence(online: $online) }
`;
